import { createReducer } from "../../../../_common/common.ts";
import {
  SET_CERTIFICADOS_PUE_STATE,
  SET_CONDICIONES_CERTIFICADOS_PUE_STATE,
  SET_CERTIFICADOS_PUE_CART_STATE
} from '../actions/constants'

const initialState = {
  certificadosPueState: null,
  condicionesCertificadosPueState: null,
  certificadosPueCartState: null,
}

export const enrollmentCertificados = createReducer(initialState, {
  [SET_CERTIFICADOS_PUE_STATE]: (state, certificadosPueState) => {
    state.certificadosPueState = certificadosPueState.data;
    return state
  },
  [SET_CONDICIONES_CERTIFICADOS_PUE_STATE]: (state, condicionesCertificadosPueState) => {
    state.condicionesCertificadosPueState = condicionesCertificadosPueState.data;
    return state
  },
  [SET_CERTIFICADOS_PUE_CART_STATE]: (state, certificadosPueCartState) => {
    state.certificadosPueCartState = certificadosPueCartState.data;
    return state
  }
});
